module.exports = __webpack_public_path__ + "img/select_drop.c4ff1548.svg";